import { useState } from 'react';
import { createRaw, patchRaw, type RawTile } from './logistics-api';

// Добавление/правка позиции оборотного склада. Остаток меняется движениями, не здесь;
// поле «начальный остаток» доступно только при создании.
export function RawEditModal({
  item,
  onClose,
  onSaved,
}: {
  item?: RawTile;
  onClose: () => void;
  onSaved: () => void;
}) {
  const edit = !!item;
  const [name, setName] = useState(item?.name ?? '');
  const [unit, setUnit] = useState(item?.unit ?? 'шт');
  const [min, setMin] = useState(String(item?.min ?? 0));
  const [qty, setQty] = useState('0');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function save() {
    if (!name.trim()) {
      setMsg('Укажите название позиции.');
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      if (edit) await patchRaw(item!.id, { name: name.trim(), unit, min: Number(min) || 0 });
      else
        await createRaw({
          name: name.trim(),
          unit,
          min: Number(min) || 0,
          qty: Number(qty) || 0,
        });
      onSaved();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось сохранить.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">{edit ? 'Правка позиции склада' : 'Новая позиция склада'}</div>
            <div className="m-no">оборотный склад · сырьё и комплектующие</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <label className="fld">
            <span className="fld-l">
              Название <span className="req">*</span>
            </span>
            <input
              value={name}
              disabled={busy}
              autoFocus
              placeholder="напр. Лист 3мм ст3"
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <div style={{ display: 'flex', gap: 10 }}>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Единица</span>
              <input
                value={unit}
                disabled={busy}
                placeholder="т / шт / лист / кг / м / компл"
                onChange={(e) => setUnit(e.target.value)}
              />
            </label>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Норма (min)</span>
              <input
                type="number"
                min="0"
                step="any"
                value={min}
                disabled={busy}
                onChange={(e) => setMin(e.target.value)}
              />
            </label>
          </div>
          {!edit && (
            <label className="fld">
              <span className="fld-l">Начальный остаток</span>
              <input
                type="number"
                min="0"
                step="any"
                value={qty}
                disabled={busy}
                onChange={(e) => setQty(e.target.value)}
              />
            </label>
          )}
          {edit && (
            <p className="muted small">
              Остаток меняется приходом/списанием («Движение…»), здесь не редактируется.
            </p>
          )}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 6 }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn sm" disabled={busy} onClick={save}>
              {busy ? 'Сохраняем…' : 'Сохранить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
